"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.057 14.887c-1.962 0-3.655-1.048-3.655-3.253h1.613c0 1.398 1.21 1.774 2.136 1.774 1.156 0 1.761-.524 1.761-1.223 0-.74-.739-.995-2.177-1.532l-.215-.081c-1.774-.672-2.863-1.223-2.863-2.756 0-1.64 1.277-2.742 3.387-2.742 1.99 0 3.495.901 3.495 3.172h-1.613c0-1.263-.914-1.694-1.895-1.694-1.075 0-1.748.484-1.748 1.143 0 .793.66 1.022 2.03 1.506l.188.067c1.667.592 3.119 1.183 3.119 2.836 0 1.586-1.197 2.783-3.563 2.783z" }), "Seasons");
//# sourceMappingURL=Seasons.js.map